export default __webpack_public_path__ + "static/newby-base-plate-b1e4615ed789f4983b8da3aa24a6e98b.jpeg";